import { PlentyGoalAccountInfo } from '../financialEntities';
import { iconNameByIraType } from './goals';
import { IconName } from './icons';

// N.B. This lives at top-level to avoid circular dependencies.
export const iconNameByPlentyGoalAccountType: Record<
    PlentyGoalAccountInfo['accountType'],
    IconName
> = {
    ROTH_IRA: iconNameByIraType['ROTH'],
    TRADITIONAL_IRA: iconNameByIraType['TRADITIONAL'],
    BROKERAGE: 'LineChartUp02', // N.B. This is just a fallback; should use goal icon.
    JOINT_BROKERAGE: 'JointPlentyAccount', // N.B. This is just a fallback; should use goal icon.
};
